import { DEFAULT_CONTENT_ALARM_MESSAGES_FIELDS } from 'pages/alarm/manage/configs';
import { instagramInitialState } from './instagramInitialState';
import { newsInitialState } from './newsInitialState';
import { telegramInitialState } from './telegramInitialState';
import { twitterInitialState } from './twitterInitialState';
import { nativePlatformsInitialState } from './nativePlatformsInitialState';
import { newspaperInitialState } from './newspaperInitialState';
import { linkedinInitialState } from './linkedinInitialState';
import { baleInitialState } from './baleInitialState';
import { rubikaInitialState } from './rubikaInitialState';
import { eitaaInitialState } from './eitaaInitialState';
import { virastyInitialState } from './virastyInitialState';
import { cafeBazaarInitialState } from './bazarInitialState';

export const alarmFiltersInitialState = {
  news: newsInitialState,
  instagram: instagramInitialState,
  telegram: telegramInitialState,
  twitter: twitterInitialState,
  newspaper: newspaperInitialState,
  nativePlatforms: nativePlatformsInitialState,
  linkedin: linkedinInitialState,
  bale: baleInitialState,
  rubika: rubikaInitialState,
  eitaa: eitaaInitialState,
  virasty: virastyInitialState,
  cafeBazaar: cafeBazaarInitialState,
};

export const alarmInitialState = {
  step: 0,
  alarmId: null,
  showStepper: false,
  alarmSource: 'socialMedia',
  selectedAppIds: [],
  type: 'content',
  reportType: 'trending', // statistical, trending, negativeIssues
  contentType: 'subject',
  selectectSubjectType: 'all', // all, single
  selectedSubjectId: undefined,
  selectedPlatforms: [],
  publicFilter: ['ignoreAdvertisment', 'onlyOriginalContents'], //  ignoreAdvertisment, onlyOriginalContents
  filters: alarmFiltersInitialState,
  selectedPreviewTab: '',
  messageFields: DEFAULT_CONTENT_ALARM_MESSAGES_FIELDS,
  title: '',
  selectedHour: null,
  durationType: 'everyDay', // everyDay, weekDays, repeatedDays
  durationValue: [],
  selectedChannelType: 'telegram',
  selectedChannelId: '',
  advancedSettingsUpdate: false,
  advancedSettingsDelete: false,
  advancedSettingsDeleteIDs: [],
  channels: {
    data: [],
    loading: false,
    error: null,
  },
  addChannel: {
    loading: false,
    error: null,
  },
  getAlarmRequest: {
    loading: false,
    error: null,
  },
  apps: {
    loading: false,
    error: null,
    data: [],
  },
  otherApps: {
    loading: false,
    error: null,
    data: [],
  },
  loading: false,
  error: null,
};
